import { Navigate, Outlet } from 'react-router-dom';

import { OrganizationUIStyle } from '@/api/rest/resources/types/organization';
import { useMatchCurrentPage } from '@/hooks/useMatchCurrentPage';
import { usePathSet } from '@/hooks/usePathSet';
import { useUIStyle } from '@/hooks/useUIStyle';

export const NoGroupByProtection = () => {
  const pathSet = usePathSet();
  const isGroupingPage = useMatchCurrentPage([
    pathSet.biodiversityDetails,
    pathSet.carbonDetails,
    pathSet.soilDetails,
    pathSet.waterDetails,
    pathSet.forestDetails,
    pathSet.deforestationDetails,
    pathSet.groups,
    pathSet.comparisons,
    pathSet.compare,
    pathSet.details,
  ]);

  const hideGroupByPages = useUIStyle(OrganizationUIStyle.CONSERVATION);

  if (isGroupingPage && hideGroupByPages) {
    return <Navigate to={pathSet.dashboard} replace />;
  }

  return <Outlet />;
};
